import {ChartType} from 'common/report/constants';

export const OTHER_SEGMENT_VALUE = `$other_segment`;

export const ChartResultChartTypes = [
  ChartType.Line,
  ChartType.StackedLine,
  ChartType.Bar,
  ChartType.StackedBar,
  ChartType.Pie,
  ChartType.Table,
];

export const EMPTY_BOOKMARK_NAME = `Untitled Insights Report`;
